var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import LoginCommonInputButton from "../common/LoginCommonInputButton";
import Timmer from "@frameworks/web/components/generic/Timmer";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
export var EMessageDisplay;
(function (EMessageDisplay) {
    EMessageDisplay["SHOW_ONLY_EMAIL"] = "SHOW_ONLY_EMAIL";
    EMessageDisplay["SHOW_ONLY_MOBILE"] = "SHOW_ONLY_MOBILE";
    EMessageDisplay["SHOW_BOTH_EMAIL_MOBILE"] = "SHOW_BOTH_EMAIL_MOBILE";
})(EMessageDisplay || (EMessageDisplay = {}));
var OTPValidation = function (props) {
    var _a;
    var isShowMaskedPhoneNumber = props.isShowMaskedPhoneNumber, _b = props.isShowMaskedEmail, isShowMaskedEmail = _b === void 0 ? !isShowMaskedPhoneNumber : _b;
    var _c = __read(React.useState(false), 2), resendOtp = _c[0], setResendOtp = _c[1];
    var _d = __read(React.useState((_a = props.timerDuration) !== null && _a !== void 0 ? _a : { minutes: 0, seconds: 60 }), 2), timerDuration = _d[0], setTimerDuration = _d[1];
    var _e = __read(React.useState(""), 2), userOTP = _e[0], setUserOTP = _e[1];
    var generateMessageComponent = function (value) {
        var _a, _b, _c;
        return (React.createElement("div", { className: (_b = (_a = value === null || value === void 0 ? void 0 : value.data) === null || _a === void 0 ? void 0 : _a.parentClassName) !== null && _b !== void 0 ? _b : "" }, (_c = value === null || value === void 0 ? void 0 : value.data) === null || _c === void 0 ? void 0 : _c.messageText));
    };
    var generateUserMaskedInfo = function () {
        var _a, _b;
        if (!!props.advancedOTPMessageConfig) {
            switch (props.advancedOTPMessageConfig.data.type) {
                case EMessageDisplay.SHOW_ONLY_EMAIL:
                    return generateMessageComponent(props.advancedOTPMessageConfig);
                case EMessageDisplay.SHOW_ONLY_MOBILE:
                    return generateMessageComponent(props.advancedOTPMessageConfig);
                case EMessageDisplay.SHOW_BOTH_EMAIL_MOBILE:
                    return generateMessageComponent(props.advancedOTPMessageConfig);
                default:
                    return React.createElement(React.Fragment, null);
            }
        }
        else if (!!isShowMaskedEmail && ((_a = props.userData) === null || _a === void 0 ? void 0 : _a.email)) {
            return (React.createElement("div", { className: " d-flex justify-content-center DMSanN_14_400 otp-validation-header " },
                React.createElement("span", { className: "text-nowrap" }, "We\u2019ve sent OTP to your email\u00A0"),
                React.createElement("span", { className: "DMSan_14_700" }, props.userData.email)));
        }
        else if (!!props.isShowMaskedPhoneNumber && ((_b = props.userData) === null || _b === void 0 ? void 0 : _b.mobile)) {
            return (React.createElement("div", { className: " d-flex justify-content-center DMSanN_14_400 otp-validation-header " },
                React.createElement("span", { className: "text-nowrap" }, "We\u2019ve sent OTP to your registered mobile Number\u00A0"),
                React.createElement("span", { className: "DMSan_14_700" }, props.userData.mobile)));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    var handleResendOTP = function () {
        if (props === null || props === void 0 ? void 0 : props.clearInputOnResend) {
            setUserOTP("");
        }
        setResendOtp(false);
        setTimerDuration({ minutes: 0, seconds: 60 });
        props.resendOTPCallback();
    };
    React.useEffect(function () {
        if (props.timerDuration) {
            setResendOtp(true);
            setResendOtp(false);
            setTimerDuration(props.timerDuration);
        }
    }, [props.timerDuration]);
    return (React.createElement("div", { className: "login-otp-validation w-100" },
        React.createElement(React.Fragment, null,
            generateUserMaskedInfo(),
            React.createElement("div", { className: "DMSanN_14_400 p-1 mt-1 mb-2 d-flex justify-content-center" }, "Enter OTP below to continue")),
        React.createElement("div", { className: "m-1 w-100 d-flex justify-content-center" },
            React.createElement(LoginCommonInputButton, { name: "partnerCode", setInputValueCallback: setUserOTP, inputValue: userOTP, inputPlaceholder: "Enter OTP", maxLength: 6, buttonText: "Continue", buttonOnClick: function () { return props.verifyOTPCallback(userOTP); }, errorConfig: {
                    isShowError: props === null || props === void 0 ? void 0 : props.error.isShowError,
                    errorMessage: React.createElement(React.Fragment, null, props === null || props === void 0 ? void 0 : props.error.errorMessage),
                }, isShowInputLoader: props.isShowLoader, buttonDisable: userOTP.length < 6 || props.isShowLoader, inputType: { integer: true }, enableClickOnEnter: true, enablePasswordMasking: true })),
        React.createElement("div", { className: "d-flex common-timer DMSanN_14_400 txt_primaryGrey" }, resendOtp ? (React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Resend OTP", className: "mt-0 resend-otp-button", onClick: handleResendOTP })) : (React.createElement("div", { className: "mt-2 d-flex" },
            React.createElement("i", { className: "edel-icon-timeout-holding " }),
            React.createElement("label", { className: "d-flex" },
                React.createElement("label", { className: "text-decoration-underline resend-otp-text plr-5" }, "Resend OTP"),
                "in",
                React.createElement(Timmer, { onTimerClose: function () { return setResendOtp(true); }, min: timerDuration.minutes, sec: timerDuration.seconds })))))));
};
export default OTPValidation;
